export default __webpack_public_path__ + "static/media/hero.6099690f.jpg";